var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCopyTestIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 437 540",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Artboard_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 437,
    height: 540
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard_1",
    "data-name": "Artboard \\u2013 1",
    clipPath: "url(#clip-Artboard_1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "copyTestIcon",
    d: "M243.944,0H29.949A26.721,26.721,0,0,0,3.2,26.749V347.741A26.742,26.742,0,0,0,29.949,374.49H163.7v53.5h53.5v-53.5H163.729v-53.5h53.465v-53.5H163.7l.033-60.255L56.7,320.992l107-107L204.34,172.4,217.194,160.5h53.5V26.749A26.742,26.742,0,0,0,243.944,0ZM163.7,187.245v26.749h53.5V160.5H190.445A26.721,26.721,0,0,0,163.7,187.245Zm107,347.741h53.5v-53.5h-53.5Zm0-320.992h53.5V160.5h-53.5Zm-107,294.242a26.742,26.742,0,0,0,26.749,26.749h26.749v-53.5H163.7ZM404.44,160.5H377.69v53.5h53.5V187.245A26.742,26.742,0,0,0,404.44,160.5ZM377.69,534.986H404.44a26.742,26.742,0,0,0,26.749-26.749V481.487h-53.5Zm0-213.994h53.5v-53.5h-53.5Zm0,107h53.5v-53.5h-53.5Z",
    transform: "translate(-2.384 0.645)",
    fill: "#3b6cab"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyTestIcon);
export default __webpack_public_path__ + "static/media/copyTestIcon.316aea7ebb0ba3c16d58c2c8435b0c59.svg";
export { ForwardRef as ReactComponent };